import { Component, Inject, OnInit } from '@angular/core';
import { ModalData, ModalRef } from '@purespectrum1/ui/modal';

export interface NotificationsModalData {
  date: string;
  emails: string[];
}

@Component({
  selector: 'ps-ui-notifications-modal',
  templateUrl: './notifications-modal.component.html',
  styleUrls: ['./notifications-modal.component.css'],
})
export class NotificationsModalComponent implements OnInit {
  public date: string;
  public emails: string[];

  constructor(
    private _modalRef: ModalRef<NotificationsModalComponent, string>,
    @Inject(ModalData)
    private _modalData: NotificationsModalData
  ) {}

  public ngOnInit(): void {
    this.date = this._modalData.emails.length ? this._modalData.date : '';
    this.emails = this._modalData.emails || [];
  }

  public close() {
    this._modalRef.close();
  }
}
